module.exports = __webpack_public_path__ + "img/shipo-icon-see.45d01ab2.svg";